<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
      <span
        v-if="tooltip"
        class="a-tooltip-secondary a-tooltip-top margin-left-xsmall font-size-small text-color-black-35"
        :data-tooltip-text="tooltip"
      >
        <i class="fas fa-info-circle"></i>
      </span>
    </label>
    <input
      :value="value"
      v-bind="$attrs"
      :class="inputError ? `a-input-primary a-input-danger ${inputClass}` : `a-input-primary ${inputClass}`"
      spellcheck="false"
      v-on="listeners"
      :ref="reference"
      @input="updateValue"
    />
    <small
      v-if="!inputError && message"
      class="font-weight-light"
    >
      <i>{{ message }}</i>
    </small>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomInputPrimary',
  inheritAttrs: false,

  props: {
    inputClass: {
      type: String,
      default: ''
    },
    inputError: Boolean,
    label: String,
    message: String,
    messageError: String,
    reference: String,
    tooltip: String,
    value: [Number, String],
    wrapperClass: String
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
